package com.rainbowclubs.rainbow.data.models

import kotlinx.serialization.Serializable

@Serializable
enum class UserRole {
    MEMBER,
    ADMIN,
    SUPER_ADMIN,
}

@Serializable
enum class MembershipStatus {
    PENDING,
    APPROVED,
    BLOCKED,
    EXPIRED,
    UNKNOWN,
}

@Serializable
data class Membership(
    val userDisplayName: String,
    val userId: String,
    val clubName: String,
    val clubId: String,
    val membershipId: String,
    val role: UserRole = UserRole.MEMBER,
    val status: MembershipStatus? = null,
    val membershipData: Map<String, String> = emptyMap(),
    val requestedAt: String? = null,
    val approvedBy: MembershipApproval? = null,
)

@Serializable
data class MembershipApproval(
    val adminUserId: String,
    val adminUserName: String,
    val approvalDate: String,
)


@Serializable
data class MembershipRequest(
    val userDisplayName: String,
    val userId: String,
    val clubId: String,
    val clubName: String,
    val membershipData: Map<String, String>,
)

@Serializable
data class MembershipsPageResponse(
    val memberships: List<Membership>,
    val page: Int,
    val limit: Int,
    val hasNextPage: Boolean,
)
